import React from "react";
import { useNavigate } from "react-router-dom";
import {
  aboutHeroBgVideo,
  facebookIcon,
  facebookIcon2,
  heroBgVideo,
  instagramIcon,
  instagramIcon2,
  newAboutImage,
  twitterIcon,
  twitterIcon2,
} from "../assets";

const AboutHero = () => {
  const navigate = useNavigate();
  return (
    <div className="relative h-[100vh] w-full rounded-b-3xl md:px-[100px] mb-16 bg-[#FFFBF2]">
      <video className="h-full object-cover" autoPlay muted loop>
        <source src={aboutHeroBgVideo} type="video/mp4" />
      </video>
      <div className="absolute hidden md:flex flex-col gap-6 left-8 top-[250px]">
        <a href="https://www.tiktok.com/@wosamhotels" target="_blank">
          <img src={twitterIcon2} alt="" className="w-3 cursor-pointer" />
        </a>
        <a href="https://www.instagram.com/wosamarena/" target="_blank">
          <img src={instagramIcon2} alt="" className="w-3 cursor-pointer" />
        </a>
        <a href="https://web.facebook.com/WosamArena/" target="_blank">
          <img src={facebookIcon2} alt="" className="w-3 cursor-pointer" />
        </a>
      </div>
      <div className="bg-[#FF9700] h-screen absolute right-0 w-[100px] top-0 md:block hidden"></div>
    </div>
  );
};

export default AboutHero;
